import GridLogo from './grid-logo';

export default class GridLogoDesktop extends GridLogo {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/grid-logo/grid-logo.desktop.js